import React from "react";

const Copyright = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto p-10 text-white bg-gray-900 rounded-lg shadow-lg mt-14 mb-20">
          <h1 className="text-4xl font-extrabold mb-6">Copyright & DMCA Policy</h1>
          <p className="text-gray-300 mb-4">Last Updated: January 20, 2026</p>

          <p className="text-lg mb-4">
            Afterparty BotLabs respects intellectual property rights and responds to
            properly formatted copyright notices under the DMCA and similar laws.
          </p>

          <h2 className="text-2xl font-bold mt-6 mb-2">Submit a takedown notice</h2>
          <p className="text-gray-300 mb-2">
            If you believe material used by our bots infringes your copyright, send a notice to:
          </p>
          <p className="text-gray-300 mb-4">
            <a href="mailto:support@afterpartylabs.xyz" className="text-blue-400 underline">
              support@afterpartylabs.xyz
            </a>
          </p>

          <p className="text-gray-300 mb-2">Your notice must include:</p>
          <ul className="list-disc list-inside text-gray-300 space-y-2">
            <li>Your contact info and a signature (typed is acceptable).</li>
            <li>Identification of the copyrighted work claimed to be infringed.</li>
            <li>Identification of the allegedly infringing material (server/bot context, message IDs, links, timestamps).</li>
            <li>A statement of good-faith belief that use is not authorized.</li>
            <li>A statement, under penalty of perjury, that the information is accurate and you are the owner or authorized to act.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-6 mb-2">Counter-notification</h2>
          <p className="text-gray-300 mb-4">
            If you believe your content was removed in error, you may submit a counter-notice
            containing comparable details. We may restore content per applicable law after the
            required waiting period if we receive no action from the original complainant.
          </p>

          <h2 className="text-2xl font-bold mt-6 mb-2">Repeat infringement</h2>
          <p className="text-gray-300">
            We may, in appropriate circumstances, disable features or access for users or servers
            that repeatedly infringe intellectual property rights.
          </p>
        </div>
      </main>
    </div>
  );
};

export default Copyright;